import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-3xl w-full md:text-4xl text-center tracking-wide z-50 break-words text-white" }




export default /*#__PURE__*/_defineComponent({
  __name: 'MediumText',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(props.text), 1))
}
}

})